import recommendationModule from './modules/recommendation'
import emailsModule from './modules/emails'

const reportsModule = {
  namespaced: true,
  modules: {
    recommendation: recommendationModule,
    emails: emailsModule
  }
}

export default reportsModule



// WEBPACK FOOTER //
// ./src/store/modules/reports/index.js